<template>
<section>
    <!-- <el-alert
      type="warning"
      :closable="false">
      <div>腾讯优图AI开放平台将于2021年12月31号下线所有产品的API接口调用服务及开发者中心页面，相关服务已上线至腾讯云官网，请尽快迁移，给您带来的不便敬请谅解。</div>
    </el-alert> -->
  <div class="open-app-header-root">
    <div class="menu-container">
      <div class="menu-item"
        :class="{'active-menu active-link' : $route.meta.isHomeActive }">
        <a class="menu-link cursor-type" @click="handleJumpPage(RouteKey.OPEN_HOME)">首页</a>
      </div>
      <div class="menu-item"
        :class="{'active-menu active-link' : $route.meta.isExperienceActive }">
        <span class="menu-link">核心技术</span>
        <div class="menu-content" @click="actionPerform">
          <div class="v3-3-experince">
            <div class="ocr-nav-container">
              <div class="ocr-nav-items">
                <div class="item-position row-one columun-one">
                  <div class="v3-3-con-title">文字识别</div>
                  <div class="v3-3-con-items" v-for="(item) in ExperienceList.ocr" :key="item.name">
                    <a :class="{'v3-3-active-link' : ($route.meta.exportKey == item.url), 'new-exp' : item.new, 'beta-exp' : item.beta}" target='_blank' :href="item.url">{{item.name}}</a>
                  </div>
                </div>
                <div class="item-position row-one columun-two">
                  <div class="v3-3-con-title">人脸识别</div>
                  <div class="v3-3-con-items" v-for="(item) in ExperienceList.face" :key="item.name">
                    <a :class="{'v3-3-active-link' : ($route.meta.exportKey == item.url && item.key == $route.query.key), 'new-exp' : item.new, 'beta-exp' : item.beta}"   target='_blank' :href="item.url">{{item.name}}</a>
                  </div>
                </div>
                <div class="item-position row-one columun-three">
                  <div class="v3-3-con-title">人脸特效</div>
                  <div class="v3-3-con-items" v-for="(item) in ExperienceList.faceEffect" :key="item.name">
                    <a :class="{'v3-3-active-link' : ($route.meta.exportKey == item.url), 'new-exp' : item.new, 'beta-exp' : item.beta}"  target='_blank' :href="item.url">{{item.name}}</a>
                  </div>
                </div>
                <div class="item-position row-one columun-four">
                  <div class="v3-3-con-title">AI平台服务</div>
                  <div class="v3-3-con-items" v-for="(item) in ExperienceList.platform" :key="item.name">
                    <a :class="{'v3-3-active-link' : ($route.meta.exportKey == item.url ), 'new-exp' : item.new, 'beta-exp' : item.beta}"  target='_blank' :href="item.url">{{item.name}}</a>
                  </div>
                </div>
                <div class="item-position row-body columun-two">
                  <div class="v3-3-con-title">人体识别</div>
                  <div class="v3-3-con-items" v-for="(item) in ExperienceList.body" :key="item.name">
                    <a :class="{'v3-3-active-link' : ($route.meta.exportKey == item.url && item.key == $route.query.key), 'new-exp' : item.new, 'beta-exp' : item.beta}"   target='_blank' :href="item.url">{{item.name}}</a>
                  </div>
                </div>
                <div class="item-position row-body columun-three">
                  <div class="v3-3-con-title">图像识别</div>
                  <div class="v3-3-con-items" v-for="(item) in ExperienceList.picture" :key="item.name">
                    <a :class="{'v3-3-active-link' : ($route.meta.exportKey == item.url), 'new-exp' : item.new, 'beta-exp' : item.beta}"  target='_blank' :href="item.url">{{item.name}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-item"
        :class="{'active-menu active-link' : $route.meta.isSolutionActive }">
        <span class="menu-link">产品服务</span>
        <div class="menu-content" @click="actionPerform">
          <div class="product-center">
            <div class="nav-item-container">
              <div class="nav-item-title">AI + 互联网系列</div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_AUDITING)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_AUDITING)">内容安全</a></div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_BROADCAST)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_BROADCAST)">视频直播</a></div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_FACEIN)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_FACEIN)">FaceIn人脸核身</a></div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_FACEIN_FW)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_FACEIN_FW)" class="new"><span>FaceIn人脸防伪</span></a></div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_ADULT)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_ADULT)" class="new"><span>未成年人内容安全审核</span></a></div>
              <div class="nav-item"><a
              :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_FORGERY)}"
              @click="handleJumpPage(RouteKey.OPEN_SOLUTION_FORGERY)" class="new"><span>证件鉴伪解决方案</span></a></div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_TIM)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_TIM)" class="new"><span>腾讯云智媒体AI中台</span></a></div>
            </div>
            <div class="nav-item-container">
              <div class="nav-item-title">金融系列</div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_INVOICE)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_INVOICE)" class="new"><span>财务票据</span></a></div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_INSURANCE)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_INSURANCE)" class="new"><span>智能保险</span></a></div>
            </div>
            <div class="nav-item-container">
              <div class="nav-item-title">AI + 教育系列</div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_EDUCATION)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_EDUCATION)" class="new"><span>优图教育</span></a></div>
            </div>
            <div class="nav-item-container">
              <div class="nav-item-title">SDK产品系列</div>
              <div class="nav-item"><a
                :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_SOLUTION_SDKPRODUCTION)}"
                @click="handleJumpPage(RouteKey.OPEN_SOLUTION_SDKPRODUCTION)" class="new"><span>泛娱乐sdk产品系列</span></a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-item"
        :class="{'active-menu active-link' : $route.meta.isCooperationActive }">
        <a class="menu-link cursor-type"
          :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_COOPERATION)}"
          @click="handleJumpPage(RouteKey.OPEN_COOPERATION)">客户案例</a>
      </div>
      <div class="menu-item" :class="{'active-menu active-link' : $route.meta.isNewsActive }">
        <a class="menu-link cursor-type" @click="handleJumpPage(RouteKey.OPEN_NEWSCENTER)">新闻中心</a>
      </div>
      <div class="menu-item" :class="{'active-menu active-link' : $route.meta.isAcademicActive }">
        <a class="menu-link cursor-type" @click="handleJumpPage(RouteKey.OPEN_ACADEMIC_RESEARCH)">学术研究</a>
      </div>
      <div class="menu-item" :class="{'active-menu active-link' : $route.meta.isAboutTTActive}">
        <a class="menu-link cursor-type"  @click="handleJumpPage(RouteKey.OPEN_ABOUTUS_INTRO)">关于我们</a>
        <!-- <div class="menu-content" @click="actionPerform">
          <div class="about-us">
            <a class="thesis-center icon-button" :class="{'active-link-content' : ($route.meta.exportKey == RouteKey.OPEN_ABOUTUS_PUBLICATIONS)}"  @click="handleJumpPage(RouteKey.OPEN_ABOUTUS_PUBLICATIONS)">
              <div class="icon"></div>
              <div class="text">学术论文</div>
            </a>
          </div>
        </div> -->
      </div>

      <div class="login-panel">
        <div v-if="$store.state.open.user.isLogin !== true">
          <div class="login-action-item action-item-split" @click="login()">登录</div>
          <div class="login-action-item action-item-split" @click="login(true)">注册</div>
          <!-- <div class="login-action-item">
            <div class="qrcode">
              <div class="dropbox">
                <i class="dropbox-arrow"></i>
                <div class="dropbox-content">
                  <img src="./img/code-youtu.jpg" class="dropbox-img">
                  <p class="dropbox-p">扫码关注<br>优图公众号</p>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div v-else class="login-info">
          <div class="user-info">
            {{$store.state.open.user.userName || $store.state.open.user.qq}}
          </div>
          <div class="action-panel">
            <div class="login-action-item action-item-split"><a @click="handleJumpPage(RouteKey.OPEN_APP_MESSAGE)">{{$store.state.open.user.news || '新消息'}}</a></div>
            <div class="login-action-item action-item-split"><a @click="handleJumpPage(RouteKey.OPEN_APP_DISPLAY)">业务申请</a></div>
            <div class="login-action-item" @click="logout">退出</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import qc from './plugin/qc';
import api from '@/common/api';
import ValidateTransferHelper from '@/components/open/common/ValidateTransferHelper';
import * as actionTypes from '@/store/open/action-types';
import RouteKey from '@/common/RouteKey';
import EventEmitter from '@/components/open/common/EventEmitter';
import Constant from '@/components/open/common/Constant';

const IS_VALID_LOGIN = 1;
const IS_VERIFYED_MAIL = 1;
const IS_VERIFY_PHONE = 1;
const ExperienceList = {
  ocr: [
    {
      name: '通用文字识别',
      url: 'https://cloud.tencent.com/product/generalocr'
    }, {
      name: '卡证文字识别',
      url: 'https://cloud.tencent.com/product/cardocr'
    }, {
      name: '票据单据识别',
      url: 'https://cloud.tencent.com/product/invoiceocr'
    }, {
      name: '汽车相关识别',
      url: 'https://cloud.tencent.com/product/vehicleocr'
    }, {
      name: '行业文档识别',
      url: 'https://cloud.tencent.com/product/documentocr',
      new: true
    }, {
      name: '智能扫码',
      url: 'https://cloud.tencent.com/product/is',
      new: true
    }, {
      name: '营业执照核验',
      url: 'https://cloud.tencent.com/product/blv'
    }, {
      name: '增值税发票核验',
      url: 'https://cloud.tencent.com/product/vtiv'
    }
  ],
  body: [
    {
      name: '手势识别',
      url: 'https://cloud.tencent.com/product/gr'
    }, {
      name: '人体分析',
      url: 'https://cloud.tencent.com/product/bda'
    }
  ],
  face: [
    {
      name: '人脸识别',
      url: 'https://cloud.tencent.com/product/facerecognition'
    }, {
      name: '换脸甄别',
      url: 'https://cloud.tencent.com/product/atdf',
      new: true
    }, {
      name: '人脸核身',
      url: 'https://cloud.tencent.com/product/faceid'
    }, {
      name: '人脸支付',
      url: 'https://cloud.tencent.com/product/frp',
      new: true
    }
  ],
  picture: [
    {
      name: '图像分析',
      url: 'https://cloud.tencent.com/product/tiia'
    }
    /* , {
      name: '智能识图',
      url: 'https://cloud.tencent.com/product/iir',
      new: true
    } */
  ],
  faceEffect: [
    {
      name: '人脸融合',
      url: 'https://cloud.tencent.com/product/facefusion'
    }, {
      name: '人脸试妆',
      url: 'https://cloud.tencent.com/product/fmu'
    }, {
      name: '人像变换',
      url: 'https://cloud.tencent.com/product/ft',
      new: true
    }
  ],
  platform: [
    {
      name: '腾讯云 TI 平台',
      url: 'https://cloud.tencent.com/product/ti',
      new: true
    }, {
      name: '人工智能服务平台',
      url: 'https://cloud.tencent.com/product/timatrix',
      new: true
    }
  ]
};

export default {
  name: 'OpenAppHeader',
  data() {
    return {
      RouteKey,
      ExperienceList
    };
  },
  methods: {
    handleJumpPage(url, key) {
      if (key != null) {
        this.$router.transfer(url, {key: key});
        return;
      }
      this.$router.transfer(url);
    },
    actionPerform(e) {
      let target = e.target || e.srcElement;
      let currentTarget = e.currentTarget;
      // 不支持currentTarget的浏览器没有效果
      if ((target.tagName.toLowerCase() !== 'a' &&
        target.parentNode.tagName.toLowerCase() !== 'a') ||
        currentTarget == null) {
        return;
      }
      currentTarget.style.display = 'none';
      setTimeout(() => {
        currentTarget.style.display = '';
      }, 300);
    },

    receiveUserInfo(result) {
      if (result.errorcode !== 0) {
        this.$alert(result.msg || '网络异常，请稍后再试');
        return;
      }
      let isVerifyMail = result.is_verify === IS_VERIFYED_MAIL;
      let isVerifyPhone = result.is_phone_verified === IS_VERIFY_PHONE;
      this.$store.dispatch(actionTypes.SAVE_USER_INFO, {
        isLogin: result.is_login === IS_VALID_LOGIN,
        isVerifyMail: isVerifyMail,
        isVerifyPhone: isVerifyPhone,
        qq: result.qq,
        userName: result.user_name,
        openid: result.openid,
        news: result.news,
        token: result.token || ''
      });
      localStorage.setItem('token', result.token);
      if (this.$route.path.indexOf('/open/experience/') !== -1) {
        return;
      }
      if (isVerifyMail && isVerifyPhone) {
        this.$router.transfer(RouteKey.OPEN_APP_DISPLAY);
      } else {
        ValidateTransferHelper.transferNext();
      }
    },

    login() {
      qc.showLogin(this.receiveUserInfo.bind(this));
    },
    logout() {
      this.$loader.get(api.user.YTLOGOUT).then(() => {
        this.$store.dispatch(actionTypes.CLEAR_USER_INFO);
        if (this.$route.path.indexOf('/open/experience/') !== -1) {
          return;
        }
        this.$router.transfer(RouteKey.OPEN_HOME);
      });
    }
  },
  created() {
    EventEmitter.register(Constant.Events.SHOW_LOGIN, this.login.bind(this));
  }
};
</script>
<style lang="less" scoped>
.open-app-header-root {
  font-family: PingFangSC-Regular,'helvetica neue','hiragino sans gb', 'microsoft yahei', tahoma,'microsoft yahei ui', simsun,sans-serif;
  background-image: url('./img/logo_youtu.svg');
  background-repeat: no-repeat;
  background-position: 30px center;
  background-size: 120px 30px;
  font-size: 0;
  text-align: center;
  position: relative;
  background-color: rgba(255,255,255,1);
  height: 63px;
  /* box-shadow: 0px 3px 15px 3px rgba(5,3,4,0.35); */
  .menu-container {
    display: inline-block;
    height: 100%;
    min-width: 700px;
    margin-left: 60px;
    .menu-item {
      display: inline-block;
      font-size: 16px;
      margin: 0 30px;
      vertical-align: middle;
      height: 100%;
      line-height: 63px;
      box-sizing: border-box;
      &:hover {
        border-bottom: 3px solid #0080FF;
        .action-link, .menu-link {
          color: #0080FF;
        }
        .menu-content {
          display: block;
        }
      }
      span.menu-link {
        cursor: default;
      }
      .menu-link {
        display: inline-block;
        width: 100%;
        height: 100%;
        letter-spacing: 1px;
        font-weight: 400;
        color: #000000;
        &.cursor-type{
          cursor: pointer;
        }
      }
      .menu-content {
        display: none;
        position: absolute;
        width: 100%;
        /* background-color: rgba(14,17,18,0.95); */
        background-color: #ffffff;
        box-shadow: 8px 8px 20px 0px rgba(0,47,73,0.1);
        border-top: 1px solid #DDE1E9;
        top: 100%;
        left: 0;
        .v3-3-experince{
          width: 1160px;
          min-height: 384px;
          margin: 0 auto;
          font-size: 0;
          position: relative;
          .face-body-container, .face-effect-container, .ocr-nav-container, .image-review-container {
            font-size: 0;
            text-align: left;
            .ocr-nav-title {
              cursor: pointer;
              box-sizing: border-box;
              position: absolute;
              left: 0;
              width: 210px;
              line-height: 68px;
              padding-left: 38px;
              font-size: 18px;
              color: #808080;
              background-position: left center, 180px center;
              background-repeat: no-repeat;
              &.new-tit:after{
                content: '';
                width: 26px;
                height: 12px;
                margin-left: 3px;
                position: absolute;
              }
              &.new-tit:after{
                top: 28px;
                background: url(./img/icon_label_new.png) no-repeat center;
              }
              &.active-title {
                color: #0080FF;
                font-weight: 900;
              }
            }
            .image-review-title{
              top: 214px;
            }
            .ocr-nav-items {
              position: absolute;
              left: 210px;
              top: 0;
              width: 950px;
              height: 100%;
              line-height: 30px;
              .item-position {
                position: absolute;
                width: 210px;
                .v3-3-con-title {
                  padding-bottom: 10px;
                  line-height: 24px;
                  font-size: 17px;
                  /* color: #ffffff; */
                  color: #3D485D;
                  border-bottom: 1px solid #E8ECF1;
                  margin-bottom: 5px;
                  width: 140px;
                }
                .v3-3-con-items {
                  cursor: pointer;
                  a {
                    color: #3D485D;
                    opacity: 0.8;
                    font-size: 15px;
                    vertical-align: top;
                    line-height: 30px;
                    position: relative;
                    &:hover {
                      color: #0080FF;
                      opacity: 1;
                    }
                    &.new-exp:after, &.beta-exp:after{
                      content: '';
                      width: 26px;
                      height: 12px;
                      margin-left: 3px;
                      position: absolute;
                    }
                    &.new-exp:after{
                      top: 4px;
                      background: url(./img/icon_label_new.png) no-repeat center;
                    }
                    &.beta-exp:after {
                      top: 5px;
                      background: url(./img/icon_label_beta.png) no-repeat center;
                    }
                  }
                  .v3-3-active-link {
                    color: #0080FF;
                    font-weight: 900;
                  }
                }
              }
              .row-one {
                top: 45px;
              }
              .row-body {
                top: 225px;
              }
              .columun-one {
                left: 0px;
              }
              .columun-two {
                left: 233px;
              }
              .columun-three {
                left: 477px;
              }
              .columun-four {
                left: 700px;
              }
              &:hover {
                display: block;
                z-index: 2;
              }
            }
            .ocr-nav-items {
              .v3-3-con-items {
                height: 30px;
                line-height: 30px;
                font-size: 14px;
              }
            }
          }
        }
        &>.product-center {
          width: 880px;
          height: 384px;
          margin: 0 auto;
          font-size: 0;
          .nav-item-container {
            width: 220px;
            .nav-item-title {
              text-align: left;
              width: 160px;
            }
          }
        }
        &>.about-us {
          width: 80px;
          height: 384px;
          margin: 0 auto;
          position: relative;
          line-height: initial;
          &>.split-line {
            position: absolute;
            width: 1px;
            height: 140px;
            border-left:1px solid #404040;
            top: 113px;
            left: 50%;
          }
          &>.icon-button {
            position: absolute;
            width: 80px;
            height: 111px;
            cursor: pointer;
            &>.icon {
              background-repeat: no-repeat;
              background-position: center;
              width: 80px;
              height: 80px;
            }
            &>.text {
              margin-top: 9px;
              font-size: 16px;
              color: #f5f5f5;
              text-align: center;
            }
            &:hover {
              &>.text {
                color: #0080FF;
              }
            }
          }
          &>.news-center {
            top: 115px;
            left: 0;
            &>.icon {
              background-image: url(./img/icon_new_normal.png);
            }
            &:hover > .icon {
              background-image: url(./img/icon_new_hover.png);
            }
            &.active-link-content{
              .icon{
                background-image: url(./img/icon_new_hover.png);
              }
              .text{
                color: #0080FF;
              }
            }
          }
          &>.thesis-center {
            top: 115px;
            right: 0;
            &>.icon {
              background-image: url(./img/icon_publication_normal.png);
            }
            &:hover > .icon {
              background-image: url(./img/icon_publication_hover.png);
            }
            &.active-link-content{
              .icon{
                background-image: url(./img/icon_publication_hover.png);
              }
              .text{
                color: #0080FF;
              }
            }
          }
        }
        .nav-item-container {
          height: 384px;
          padding: 16px 0 0;
          box-sizing: border-box;
          color: #ffffff;
          display: inline-block;
          vertical-align: top;
          overflow: hidden;
          .nav-item-title {
            font-size: 20px;
            /* color: #808080; */
            color: #3D485D;
            border-bottom: 1px solid #E8ECF1;
            width: 150px;
            background-position: left center;
            background-repeat: no-repeat;
            margin-bottom: 18px;
            line-height: 58px;
            padding-left: 3px;
            text-align: center;
          }
          .nav-item {
            height: 30px;
            line-height: 30px;
            text-align: left;
            cursor: pointer;
            a {
              /* color: #ffffff; */
              font-size: 14px;
              display: block;
              overflow: hidden;
              width: 100%;
              height: 30px;
              color: #3D485D;
              opacity: 0.8;
              &:hover {
                color: #0080FF;
                opacity: 1;
              }
              > span {
                display: inline-block;
                height: 30px;
                line-height: 30px;
                vertical-align: top;
              }
              &.new:after {
                content: '';
                width: 26px;
                height: 30px;
                display: inline-block;
                overflow: hidden;
                vertical-align: top;
                /* vertical-align: middle; */
                background: url(./img/icon_new.png) center center no-repeat;
                margin-left: 8px;
              }
            }
            .active-link-content{
              color: #0080FF;
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .login-panel {
    @panel-line-height: 63px;
    position: absolute;
    right: 0;
    top: 0;
    line-height: @panel-line-height;
    @split-margin: 10px;
    .login-action-item {
      display: inline-block;
      box-sizing: border-box;
      width: 72px;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      cursor: pointer;
      /* margin-right: @split-margin; */
      vertical-align: middle;
      &:hover {
        color: #0080FF;
        // background: #0080FF;
      }
      /* &.action-item-split:after {
        margin-left: @split-margin;
        content: '';
        display: inline-block;
        height: 12px;
        width: 1px;
        vertical-align: middle;
        background-color: #ffffff;
      } */
      &>.qrcode {
        width: 18px;
        height: 18px;
        background: url(./img/navibar_QRcode_normal.png) no-repeat;
        background-position: center;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        position: relative;
        &:hover {
          background: url(./img/navibar_QRcode_hover.png) no-repeat;
          .dropbox {
            display: inline-block;
          }
        }
        .dropbox {
          display: none;
          right: -13px;
          top: 24px;
          position: absolute;
          margin: 12px 0px 0 48px;
          background-color: #fff;
          box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.31);
          border: 1px solid #ccc;
          border: 0 rgba(0, 0, 0, 0);
          line-height: initial;
        }
        .dropbox-arrow {
          position: absolute;
          width: 0;
          height: 0;
          top: -29px;
          left: 122px;
          border-width: 15px;
          border-color: transparent transparent #fff;
          border-style: dashed dashed solid;
          overflow: hidden;
        }
        .dropbox-content {
          padding: 10px;
        }
        .dropbox-img {
          width: 139px;
          height: 139px;
        }
        .dropbox-p {
          font-size: 16px;
          color: #252525;
          text-align: center;
        }
      }
    }
    .login-info {
      line-height: @panel-line-height / 2;
      margin-right: 20px;
      text-align: right;
      .user-info {
        padding-top: 4px;
        display: block;
        font-size: 14px;
        height: 31px;
        text-align: right;
        margin-right: @split-margin;
      }
      .action-panel {
        padding-bottom: 4px;
        line-height: @panel-line-height / 2 - 6px;
        a {
          font-size: 14px;
          &:hover {
            color: #0080FF;
          }
        }
      }

    }
  }
  .active-menu.active-link{
    .action-link, .menu-link {
      /* color: #0080FF; */
      color: #0080FF;
    }
  }
  .active-menu{
    border-bottom: 3px solid #0080FF;
  }
}

/* @media (min-width: 1900px) {
  .open-app-header-root {
    background-image: url(./img/navibar_logo_youtuai_new.png);
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/open/common/OpenAppHeader.vue